import { RequestManager, Fetch, CacheHandler } from "@warp-drive/core";
import { service } from "@ember/service";
import ENV from "glesys-controlpanel/config/environment";
import { WithDefaultHeaders, WithAuthToken, ioApiBaseUri } from "glesys-controlpanel/data/handlers";

export { ioApiBaseUri, isApiDirectlyUri } from "glesys-controlpanel/data/handlers";

const getUrl = (url) => new URL(url, document.location.origin);

export const isIoUrl = (url) => /^\/io\.php(?:\/|$)/.test(getUrl(url).pathname);

const WithApiBaseUri = {
  async request(context, next) {
    let apiBaseUri = isIoUrl(context.request.url) ? ioApiBaseUri : ENV.apiBaseUri;

    let url = new URL(context.request.url, apiBaseUri).toString();

    return next(Object.assign({}, context.request, { url }));
  },
};

const ParseApiResponse = {
  async request(context, next) {
    let response = await next(context.request);

    let content = response.content?.response ?? response.content;
    return { ...response, content };
  },
};

export default class Http extends RequestManager {
  @service session;

  constructor(createArgs) {
    super(createArgs);
    this.use([WithDefaultHeaders, WithApiBaseUri, WithAuthToken(this.session), ParseApiResponse, Fetch]);
    this.useCache(CacheHandler);
  }

  request(requestInfo) {
    const request = Object.assign({}, requestInfo);
    if (request.body) {
      request.body = JSON.stringify(request.body);
    }

    return super.request(request);
  }

  withContext(context) {
    return new Proxy(this, {
      get(target, prop, receiver) {
        if (prop === "request") {
          return (requestInfo) => target.request({ ...requestInfo, options: { ...requestInfo.options, context } });
        }

        return Reflect.get(target, prop, receiver);
      },
    });
  }
}
